import { render, staticRenderFns } from "./StatisticMetricsCard.vue?vue&type=template&id=67e937a8&scoped=true&"
import script from "./StatisticMetricsCard.vue?vue&type=script&lang=js&"
export * from "./StatisticMetricsCard.vue?vue&type=script&lang=js&"
import style0 from "./StatisticMetricsCard.vue?vue&type=style&index=0&id=67e937a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e937a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VIcon,VListItem,VListItemContent,VListItemTitle,VProgressLinear,VTooltip})
